<!-- <ng-container *ngIf="!selectedUserListItem"> -->
<!--
  <div class="card mt-5"> -->

<div class="rc-edit-form-bg">
  <p-table styleClass="p-datatable-striped p-datatable-sm"
           [columns]="userListDisplayColumns"
           [value]="dataSource"
           selectionMode="single"
           [(selection)]="selectedUserListItem"
           scrollabe="true"
           [scrollHeight]="tableHeight"
           dataKey="id"
           (onRowSelect)="onRowSelect($event)"
           responsiveLayout="stack"
           [breakpoint]="'960px'"
           [tableStyle]="{'min-width': '50rem'}">
    <ng-template pTemplate="caption">
      <div class="flex align-items-center justify-content-between">
        Users
        <p-button class="btn btn-primary"
                  (click)="onAddNewUser()">Add User</p-button>
        <p-button class="btn btn-primary"
                  (click)="onDone()">Done</p-button>
      </div>
    </ng-template>
    <ng-template pTemplate="header"
                 let-columns>
      <tr>
        <th *ngFor="let col of columns"
            [style.width]="col.width">
          {{ col.header }}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body"
                 let-rowData
                 let-columns="columns">
      <tr id="userTableRowId"
          [pSelectableRow]="rowData">
        <td *ngFor="let col of columns"
            [ngSwitch]="col.field">
          <span class="p-column-title">{{col.header}}</span>
          <ng-container *ngSwitchCase="'actions'">
            <ng-container>
              <div class="flex justify-content-center flex-wrap gap-1">
                <p-button class="action-button"
                          icon="pi pi-user-edit"
                          [rounded]="true"
                          (click)="onEditUser(rowData);$event.stopPropagation()"
                          pTooltip="Edit User"></p-button>
                <p-button class="action-button"
                          icon="pi pi-user-plus"
                          [rounded]="true"
                          (click)="onAddUserToFirebase(rowData);$event.stopPropagation()"
                          pTooltip="Add Firebase User"></p-button>
                <p-button class="action-button"
                          icon="pi pi-undo"
                          [rounded]="true"
                          (click)="onResetPassword(rowData);$event.stopPropagation()"
                          pTooltip="Password Reset"></p-button>
                <p-button class="action-button"
                          icon="pi pi-trash"
                          [rounded]="true"
                          (click)="onDeleteUser(rowData)"
                          pTooltip="Delete User"></p-button>
              </div>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchDefault> {{ rowData[col.field] }}
          </ng-container>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
<!-- </div> -->
<!-- </ng-container> > -->
<!--
<div *ngIf="selectedUserListItem && editUserForm"
     class="rc-container">
  <app-edit-user [selectedUserListItem]="selectedUserListItem"
                 [editUserForm]="editUserForm"
                 (onSaveUserEdit)="onSaveUserEdit()"
                 (onCancelUserEdit)="onCancelUserEdit()">
  </app-edit-user>
</div> -->